import React from 'react';
import styled from 'styled-components';
import {
  IRowMeta,
  setBuilderCustomOrderAction,
} from '../../../../redux/slices/oldBuilder';
import {
  FunnelOrderKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  stepOrdersSelector,
} from '../../../../redux/selectors/builder';
import { assertCondition, assertNotNil } from '../../../../utils/types';
import { funnelOrderTooltips } from '../../../KubitTooltip/globalTooltips';
import {
  SingleSelect,
  SingleSelectLabel,
  SingleSelectOption,
} from '../../../Dropdown/SingleSelect';
import { ConnectorWrapper } from '../../BuilderUI';
import KubitTooltip from '../../../KubitTooltip';

interface IProps {
  rowMeta: IRowMeta;
}

const StyledWrapper = styled(ConnectorWrapper)`
  &:hover {
    cursor: pointer;
  }
`;

const BuilderStepCustomOrder = ({ rowMeta }: IProps) => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );

  assertCondition(defaultOptions?.type === QueryType.Funnel);

  const { funnelCustomOrders } = defaultOptions;

  const stepCustomOrder = useAppSelector(stepOrdersSelector(rowMeta));

  const handleChange = (newOrder: FunnelOrderKey) => {
    dispatch(
      setBuilderCustomOrderAction({
        newOrder,
        rowMeta,
      }),
    );
  };

  const selectedFunnelOrder =
    funnelCustomOrders.find(
      (customOrder) => customOrder.key === stepCustomOrder,
    ) || null;
  assertNotNil(selectedFunnelOrder);

  return (
    <SingleSelect
      menuMinWidth={100}
      trigger={
        <div>
          <KubitTooltip {...funnelOrderTooltips[selectedFunnelOrder.key]}>
            <StyledWrapper>
              <SingleSelectLabel>{selectedFunnelOrder.name}</SingleSelectLabel>
            </StyledWrapper>
          </KubitTooltip>
        </div>
      }
      placement="bottom-start"
    >
      {funnelCustomOrders.map((order) => (
        <SingleSelectOption
          key={order.name}
          label={order.name}
          onClick={() => handleChange(order.key)}
        />
      ))}
    </SingleSelect>
  );
};

export default BuilderStepCustomOrder;
